<template>
  <div class="row">
    <user-menu v-if="$route.params.userId"></user-menu>
    <div class="col-md-10 pt-3" v-if="loginUser.userId == postData.userId || hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')">
      
      <form @submit.prevent="submit" autocomplete="off" class="p-2">
        <h2 class="subhead">基本情報</h2>
        <div class="form-group">
          <label for="userName">氏名</label>
          <p>{{userName}}</p>
        </div>
        <div class="form-group">
          <label for="userName">現住所</label>
          <div class="form-group form-inline">
            <label class="mr-1">〒</label>
            <input type="number" class="form-control form-control-sm" v-model="currentPostalCode1" style="max-width:60px">
            <span class="mr-1 ml-1"> - </span>
            <input type="number" class="form-control form-control-sm" v-model="currentPostalCode2" style="max-width:80px">
          </div>
          <input type="text" class="form-control col-sm-6" placeholder="例）東京都港区芝浦３丁目１４−１９" v-model="postData.currentAddress">
        </div>
        <div class="form-group">
          <label for="userName">住民票住所</label>
          <div class="form-group form-inline">
            <label class="mr-1">〒</label>
            <input type="number" class="form-control form-control-sm" v-model="residenceCardPostalCode1" style="max-width:60px">
            <span class="mr-1 ml-1"> - </span>
            <input type="number" class="form-control form-control-sm" v-model="residenceCardPostalCode2" style="max-width:80px">
          </div>
          <input type="text" class="form-control col-sm-6" placeholder="例）東京都港区芝浦３丁目１４−１９" v-model="postData.residenceCardAddress">
        </div>
        <div class="form-group">
          <label>携帯電話</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.tel1">
        </div>
        <div class="form-group">
          <label>携帯メールアドレス</label>
          <input type="mail" class="form-control col-sm-6" autocomplete="nope" v-model="postData.mail">
        </div>
        <div class="form-group">
          <label>緊急連絡先番号</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.tel2">
        </div>
        <div class="form-group">
          <label>緊急連絡先宛先</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.destination">
        </div>

        <!-- 交通手段 -->
        <h2 class="subhead mt-5">交通手段</h2>
        <h3 class="mt-4">バス</h3>
        <div class="form-group">
          <label>バス会社名</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.busCompanyName">
        </div>
        <div class="form-group">
          <label>自宅最寄停留所</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.busStart">
        </div>
        <div class="form-group">
          <label>駅最寄停留所</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.busEnd">
        </div>
        <div class="form-group form-inline">
            <label class="mr-2">片道</label>
            <input type="number" class="form-control mr-2" autocomplete="nope" v-model="postData.busOneWayExpense">
            <label class="mr-2">1ヶ月定期代</label>
            <input type="number" class="form-control" autocomplete="nope" v-model="postData.busMonthlyExpense">
        </div>
        <h3 class="mt-4">電車</h3>
        <div class="form-group">
          <label>自宅最寄駅</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.trainStartStation">
        </div>
        <div class="form-group">
          <label>会社最寄駅</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.trainEndStation">
        </div>
        <div class="form-group">
          <label>使用路線</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.trainRoute">
        </div>
        <div class="form-group form-inline">
            <label class="mr-2">片道</label>
            <input type="number" class="form-control mr-2" autocomplete="nope" v-model="postData.trainOneWayExpense">
            <label class="mr-2">1ヶ月定期代</label>
            <input type="number" class="form-control" autocomplete="nope" v-model="postData.trainMonthlyExpense">
        </div>

        <!-- 個人情報 -->
        <h2 class="subhead mt-5">個人情報</h2>
        <div class="form-group form-inline">
          <label class="mr-2">銀行名</label>
          <input type="text" class="form-control mr-2" autocomplete="nope" v-model="postData.bankName">
          <label class="mr-2">銀行番号</label>
          <input type="text" class="form-control" autocomplete="nope" v-model="postData.bankNumber">
        </div>
        <div class="form-group form-inline">
          <label class="mr-2">支店名</label>
          <input type="text" class="form-control mr-2" autocomplete="nope" v-model="postData.bankBranchName">
          <label class="mr-2">支店番号</label>
          <input type="text" class="form-control" autocomplete="nope" v-model="postData.bankBranchNumber">
        </div> 
        <div class="form-group">
          <label>預金タイプ</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.bankAccountType">
        </div> 
        <div class="form-group">
          <label>口座番号（7ケタ）</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.bankAccountNumber">
        </div> 
        <div class="form-group">
          <label>口座名義人（カナ）</label>
          <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.bankAccountHolder">
        </div> 
      
        <div v-if="loginUser.userId == postData.userId || hasAnyRole('ROLE_ADMIN')"> 
          <div class="form-group">
            <label>基礎年金番号</label>
            <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.basicPensionNumber">
          </div> 
          <div class="form-group">
            <label>被保険者番号</label>
            <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.insuredNumber">
          </div> 
          <div class="form-group">
            <label>個人番号</label>
            <input type="text" class="form-control col-sm-6" autocomplete="nope" v-model="postData.personalNumber">
          </div> 
        </div>

        <div v-if="!edit" class="form-group">
          <label>定期券</label>
          <input @change="selectedFile" type="file" name="file" id="newUploadFile">
        </div>

        <button v-if="$route.params.userId" type="button" class="btn btn-secondary m-2" @click="goBack">戻る</button>
        <input v-if="edit" type="submit" class="btn btn-primary" value="編集"/>
        <input v-else type="submit" class="btn btn-primary" value="登録"/>
      </form>

      <toast ref="toast"></toast>

      <!-- 写真タブ -->
      <div v-if="edit" class="col-12 mt-3">
          <h2 class="subhead mt-5">定期券写真</h2>
          <table class="table">
            <tr>
              <td><label>現在の画像</label></td>
              <td>
                <img v-if="postData.imageUrl" class="card-img-top icon" id="byteImage" />
                <span v-else>なし</span> 
                <button v-if="postData.imageUrl" class="btn btn-sm btn-outline-danger m-1" style="border-radius:50px;" @click.stop="deleteAttachment">
                    <i class="fa fa-trash"></i>
                    画像を削除
                </button>
              </td>
            </tr>
            <tr>
              <td><label>新しい画像</label></td>
              <td>
                <form  @submit.prevent="upload">
                    <input @change="selectedFile" type="file" name="file" id="uploadFile">
                    <button v-if="uploadFile" type="submit" class="btn btn-info" style="border-radius:50px;">
                        <i class="fa fa-cloud-upload fa-1x" aria-hidden="true"></i>アップロード
                    </button>
                </form>
              </td>
            </tr>
          </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.subhead{
  display: flex;
  padding-bottom: 8px;
  margin-bottom: 16px;
  border-bottom: 1px #e1e4e8 solid;
  flex-flow: row wrap;
}
.icon {
  width:auto;
  height:auto;
  max-width:100%;
  max-height:100%;
}
.table tr td {
  border-top: none;
}
</style>

<script>
import UserAPI from '../../../api/user-api'
import CommonAPI from '../../../api/common-api'
import Toast from '../../Toast.vue'
import UserMenu from '../../admin/user/UserMenu.vue'
import moment from 'moment'

export default {
  name: "user-work-registration-new-edit",
  components: {
    UserMenu,
    Toast
  },
  props: {
    propsLoginUser: Object,
  },
  data() {
    return {
      id: null,
      edit: false,
      loginUser: {
        role: 'ROLE_USER'
      },
      userName: '',
      currentPostalCode1: '',
      currentPostalCode2: '',
      residenceCardPostalCode1: '',
      residenceCardPostalCode2: '',
      postData: {
        userId: null,
        mail: '',
        busOneWayExpense: 0,
        busMonthlyExpense: 0,
        trainOneWayExpense: 0,
        trainMonthlyExpense: 0,
        sumOneWayExpense: 0,
        sumMonthlyExpense: 0,
        currentAddress: '',
        currentPostalCode: '',
        residenceCardAddress: '',
        residenceCardPostalCode: '',
      },
      uploadFile: null,
    }
  },
  watch: {
    'currentPostalCode1': function (to, from) {
      if(to && to.length > 3){
        this.currentPostalCode1 = to.slice(0, 3)
      }
      if(this.currentPostalCode1.length == 3 && this.currentPostalCode2.length == 4){
        this.postData.currentPostalCode = this.currentPostalCode1 + '' + this.currentPostalCode2
      }
      if(this.postData.currentPostalCode.length == 7 && !this.postData.currentAddress) {
        this.searchAddress1()
      }
    },
    'currentPostalCode2': function (to, from) {
      if(to && to.length > 4){
        this.currentPostalCode2 = to.slice(0, 4)
      }
      if(this.currentPostalCode1.length == 3 && this.currentPostalCode2.length == 4){
        this.postData.currentPostalCode = this.currentPostalCode1 + '' + this.currentPostalCode2
      }
      if(this.postData.currentPostalCode.length == 7 && !this.postData.currentAddress) {
        this.searchAddress1()
      }
    },
    'residenceCardPostalCode1': function (to, from) {
      if(to && to.length > 3){
        this.residenceCardPostalCode1 = to.slice(0, 3)
      }
      if(this.residenceCardPostalCode1.length == 3 && this.residenceCardPostalCode2.length == 4){
        this.postData.residenceCardPostalCode = this.residenceCardPostalCode1 + '' + this.residenceCardPostalCode2
      }
      if(this.postData.residenceCardPostalCode.length == 7 && !this.postData.residenceCardAddress) {
          this.searchAddress2()
      }
    },
    'residenceCardPostalCode2': function (to, from) {
      if(to && to.length > 4){
        this.residenceCardPostalCode2 = to.slice(0, 4)
      }
      if(this.residenceCardPostalCode1.length == 3 && this.residenceCardPostalCode2.length == 4){
        this.postData.residenceCardPostalCode = this.residenceCardPostalCode1 + '' + this.residenceCardPostalCode2
      }
      if(this.postData.residenceCardPostalCode.length == 7 && !this.postData.residenceCardAddress) {
          this.searchAddress2()
      }
    },
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
        this.loginUser = val
        this.init()
    },
  },
  mounted () {
    this.$root.$refs.loading.$data.show = false
    if(this.propsLoginUser){
      this.loginUser = this.propsLoginUser
      this.init()
    }
  },
  methods: {
    // 新規 or 更新の判定
    init () {
      // ユーザ情報取得
      if (this.$route.params.userId) {
        this.postData.userId = this.$route.params.userId
        this.getUser(this.$route.params.userId)

        // ID指定があれば編集モード(管理者と一般でパラメータの指定方法が違う)
        if (this.$route.query.id) {
          this.edit = true
          this.getWorkRegistration(this.$route.query.id)
        }
      } else {
        this.postData.userId = this.loginUser.userId
        this.userName = this.loginUser.userName

        if (this.loginUser.userWorkRegistrationList && this.loginUser.userWorkRegistrationList.length > 0){
          this.getWorkRegistration(this.loginUser.userWorkRegistrationList[0].id)
        }
      }
    },
    // ユーザ取得
    getUser (id) {
      this.$root.$refs.loading.$data.show = true
      UserAPI.getUser(id)
          .then(res => {
            this.userName = res.userName
            this.$root.$refs.loading.$data.show = false
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    },
    // ユーザ勤務登録取得
    getWorkRegistration (id) {
      this.$root.$refs.loading.$data.show = true
      UserAPI.getUserWorkRegistration(id)
          .then(res => {
            if(res){
              this.postData = res
              if(res.currentPostalCode.length == 7){
                this.currentPostalCode1 = res.currentPostalCode.slice(0,3)
                this.currentPostalCode2 = res.currentPostalCode.slice(3, 7)
              }
              if(res.residenceCardPostalCode.length == 7){
                this.residenceCardPostalCode1 = res.residenceCardPostalCode.slice(0,3)
                this.residenceCardPostalCode2 = res.residenceCardPostalCode.slice(3, 7)
              }
              if(res.imageUrl != null){
                this.download()
              }
            }
            this.$root.$refs.loading.$data.show = false
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    },
    submit () {
      this.$root.$refs.loading.$data.show = true
      this.postData.sumOneWayExpense = this.postData.busOneWayExpense + this.postData.trainOneWayExpense
      this.postData.sumMonthlyExpense = this.postData.busMonthlyExpense + this.postData.trainMonthlyExpense
      if (this.edit){
        // 編集
        UserAPI.editUserWorkRegistration(this.postData)
            .then(res => {
              this.$refs.toast.showToast("更新しました", 3000, false)
              this.$root.$refs.loading.$data.show = false
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
      } else {
        // 新規登録
        UserAPI.createUserWorkRegistration(this.postData)
            .then(res => {
              if(res){
                this.postData.id = res
                this.upload()
              }
              this.$refs.toast.showToast("更新しました", 3000, false)
              this.goBack()
              this.$root.$refs.loading.$data.show = false
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
      }
    },
    // 前の画面へ
    goBack () {
        this.$root.$refs.loading.$data.show = true
        this.$router.go(-1)
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    // 郵便番号検索（現住所）
    searchAddress1(){
      this.$root.$refs.loading.$data.show = true
      CommonAPI.searchAddress(this.postData.currentPostalCode)
            .then(res => {
              let result = res.results;
              if(result.length > 0){
                  this.postData.currentAddress = result[0].address1 + result[0].address2 + result[0].address3
                  this.$forceUpdate();
              }
              this.$root.$refs.loading.$data.show = false
            })
            .catch(err => {
              this.$root.$refs.loading.$data.show = false
            })
    },
    // 郵便番号検索（住民票住所）
    searchAddress2(){
      this.$root.$refs.loading.$data.show = true
        CommonAPI.searchAddress(this.postData.residenceCardPostalCode)
        .then(res => {
          let result = res.results;
          if(result.length > 0){
              this.postData.residenceCardAddress = result[0].address1 + result[0].address2 + result[0].address3
              this.$forceUpdate();
              this.$root.$refs.loading.$data.show = false
          }
        })
        .catch(err => {
          this.$root.$refs.loading.$data.show = false
        })
    },
    // ファイル削除
    deleteAttachment() {
        if (window.confirm('削除しますか？')){
            this.$root.$refs.loading.$data.show = true
            UserAPI.deleteUserWorkRegistrationFile(this.postData.userId, this.postData.id)
                .then(res => {
                    this.uploadFile = null
                    document.getElementById('uploadFile').value = ''
                    document.getElementById('newUploadFile').value = ''
                    this.$root.$refs.loading.$data.show = false
                    this.$refs.toast.showToast("ファイルを削除しました", 3000, false)
                    this.getWorkRegistration(this.postData.id)
                })
                .catch(err => {
                    console.error(err)
                    this.$root.$refs.loading.$data.show = false
                })
        }
    },
    // ファイル選択
    selectedFile(e) {
        e.preventDefault();
        let files = e.target.files;
        this.uploadFile = files[0];
        this.isInvalidFile()
    },
    // ファイル検証
    isInvalidFile() {
        // サイズチェック
        if (this.uploadFile.size >= 2000000) {
            this.$refs.toast.showToast("※2MB以上のファイルはアップロードできません。", 3000, true)
            this.uploadFile = null
            document.getElementById('uploadFile').value = ''
            document.getElementById('newUploadFile').value = ''
            return true
        }
        // ファイルタイプチェック
        let splits =this.uploadFile.name.toLowerCase().split(".");
        let extension = splits[splits.length - 1];
        let allowExtension = ["pdf", "jpg", "jpeg", "png",];
        if (allowExtension.indexOf(extension) < 0){
            this.$refs.toast.showToast("※PDF/JPG/PNG以外のファイルはアップロードできません。", 3000, true)
            this.uploadFile = null
            document.getElementById('uploadFile').value = ''
            document.getElementById('newUploadFile').value = ''
            return true
        }
        return false
    },
    // アップロード
    upload() {
        // バリデーション
        if(this.uploadFile == null || this.isInvalidFile()){
            return
        }
        this.$root.$refs.loading.$data.show = true
        let formData = new FormData();
        formData.append('file', this.uploadFile);
        UserAPI.uploadUserWorkRegistration(this.postData.userId, this.postData.id, formData)
            .then(res => {
                this.uploadFile = null
                document.getElementById('uploadFile').value = ''
                document.getElementById('newUploadFile').value = ''
                this.$root.$refs.loading.$data.show = false
                this.$refs.toast.showToast("ファイルをアップロードしました。", 3000, false)
                this.getWorkRegistration(this.postData.id)
            })
            .catch(err => {
                console.error(err)
                this.$root.$refs.loading.$data.show = false
            })
    },
    download(){
        UserAPI.downloadUserWorkRegistration(this.postData.userId, this.postData.id)
            .then(res => {
              document.getElementById("byteImage").src = res
            })
            .catch(err => {
                console.error(err)
            }) 
    }
  },
  computed: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/common/user/UserWorkRegistrationNewEdit.vue